<template>
  <RouterLink :to="to" class="table-row-link" :aria-label="ariaLabel" @click.stop>
    <span class="table-row-link__content">
      <slot />
    </span>
  </RouterLink>
</template>

<script>
  export default {
    name: 'TableRowLink',

    props: {
      to: {
        type: [String, Object],
        required: true,
      },
      ariaLabel: {
        type: String,
        default: null,
      },
    },
  };
</script>
